import { Loading } from '@components/common/Loading/Loading';
import { Secured } from '@components/Secured/Secured';
import { lazy } from 'react';
import { RouteObject } from 'react-router';

import { PharmacyDictionariesCard } from '@/pages/Pharmacy/components/card/PharmacyDictionaryCard';
import { MonitoringHistory } from '@/pages/Pharmacy/components/history/MonitoringHistory';
import { Monitoring } from '@/pages/Pharmacy/components/Monitoring/Monitoring';
import { pharmacy } from '@/shared/security/permissions/pharmacy';

import { PharmacyDictionaries } from './components/PharmacyDictionaries';

const LazyPharmacy = lazy(() =>
  import('./PharmacyPage').then((module) => ({
    default: module.PharmacyPage,
  })),
);

const baseRoute: RouteObject = {
  path: '/pharmacy',
  element: <Loading children={<LazyPharmacy />} />,
  children: [],
};

const dictionariesRoutes = [
  {
    path: '/pharmacy/dictionaries',
    element: (
      <Secured security={{ permissions: pharmacy.dictionary.viewDrugs }}>
        <PharmacyDictionaries />
      </Secured>
    ),
  },
  {
    path: '/pharmacy/dictionaries/:id',
    element: (
      <Secured security={{ permissions: pharmacy.dictionary.viewDrug }}>
        <PharmacyDictionariesCard />
      </Secured>
    ),
  },
  {
    path: '/pharmacy/monitoring',
    element: (
      <Secured security={{ permissions: pharmacy.monitoring.viewDrugs }}>
        <Monitoring />
      </Secured>
    ),
  },
  {
    path: '/pharmacy/monitoring/history',
    element: (
      <Secured security={{ permissions: pharmacy.monitoring.viewDrugs }}>
        <MonitoringHistory />
      </Secured>
    ),
  },
];
baseRoute.children = [...dictionariesRoutes];
const routes = baseRoute.children.length > 0 ? [baseRoute] : [];

export const PharmacyRoutes = routes;
